export default __webpack_public_path__ + "navigation-guides-turn-by-turn-ui-map-1200-d689dd32ffb1b50c44885c432f6b9008.png";